{/* <html>

<head>
  <meta charset="utf-8" />
  <style>
    .pydocx-caps {
      text-transform: uppercase
    }

    .pydocx-center {
      text-align: center
    }

    .pydocx-comment {
      color: blue
    }

    .pydocx-delete {
      color: red;
      text-decoration: line-through
    }

    .pydocx-hidden {
      visibility: hidden
    }

    .pydocx-insert {
      color: green
    }

    .pydocx-left {
      text-align: left
    }

    .pydocx-list-style-type-cardinalText {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimal {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedCircle {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedFullstop {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalEnclosedParen {
      list-style-type: decimal
    }

    .pydocx-list-style-type-decimalZero {
      list-style-type: decimal-leading-zero
    }

    .pydocx-list-style-type-lowerLetter {
      list-style-type: lower-alpha
    }

    .pydocx-list-style-type-lowerRoman {
      list-style-type: lower-roman
    }

    .pydocx-list-style-type-none {
      list-style-type: none
    }

    .pydocx-list-style-type-ordinalText {
      list-style-type: decimal
    }

    .pydocx-list-style-type-upperLetter {
      list-style-type: upper-alpha
    }

    .pydocx-list-style-type-upperRoman {
      list-style-type: upper-roman
    }

    .pydocx-right {
      text-align: right
    }

    .pydocx-small-caps {
      font-variant: small-caps
    }

    .pydocx-strike {
      text-decoration: line-through
    }

    .pydocx-tab {
      display: inline-block;
      width: 4em
    }

    .pydocx-underline {
      text-decoration: underline
    }

    body {
      margin: 0px auto;
      width: 51.00em
    }
  </style>
</head>

<body> */}
  let termsEN =`
  <p>
    <strong>CONSUMER FRAUD ALERT: PROTECT YOURSELF. BE CAREFUL WHEN A STRANGER ASKS YOU TO SEND MONEY, ESPECIALLY FOR INTERNET AUCTIONS, 
    NEWSPAPER OR TELEPHONE OFFERS</strong> Barri does not guarantee delivery or 
    suitability of goods or services paid for with Services. Barri is not an escrow service provider. Customer and 
    Beneficiary agree not to use Services for escrow purposes.</p>
  <p>Notify Barri immediately if you believe your Barri username and password have been lost or stolen or if someone 
  may use them without your permission.</p>
  <ol class="pydocx-list-style-type-decimal">
    <li>
      <strong>BARRI MONEY TRANSFER SERVICES ("SERVICES") ARE PROVIDED BY BARRI MONEY SERVICES, LLC ("BARRI") 
      AND ARE SUBJECT TO THESE TERMS AND CONDITIONS ("AGREEMENT") AND APPLICABLE LAW.</strong>  Additional 
      information regarding the Services may be obtained at <a href="http://www.barri.com">www.barri.com</a> depending on the services you choose. 
      Service and funds availability depends on certain factors including the Service selected, the selection of 
      delayed delivery options, amount sent, destination country, currency availability, regulatory issues, consumer 
      protection issues, identification requirements, delivery restrictions, agent location hours, and differences in 
      time zones (collectively, "Restrictions"). The designated recipient ("Beneficiary") may generally receive funds 
      sent by Barri consumer ("You") at Agent locations in the Expected Payout Location. For transactions sent within 
      the U.S., the Expected Payout Location generally means any Agent location in the destination state or U.S. 
      territory you identify. For transactions sent outside the U.S., Expected Payout Location generally means any 
      Agent location in the destination country you identify. You may pay for the Services by using a U.S. issued Visa 
      or MasterCard credit card, or debit card issued by or through a financial institution located in the U.S. ("Bank 
      Card"). Alternatively, you may pay with cash at a Barri agent location or using Barri's mobile phone, or ACH 
      options ("Alternative Payment Options"). The total due is payable before Barri processes the transaction. If 
      Barri does not receive authorization from the Bank Card issuer (or your account provider, in the case of 
      Alternative Payment Options), the transaction will not be processed and funds will not be transmitted to the 
      Beneficiary. Each time You use your Bank Card or Alternative Payment Options to pay for Services, you agree 
      that Barri is authorized to charge your designated Bank Card or applicable account for the total disclosed to 
      you relating to the transaction. Beneficiary will normally receive funds sent by you in cash, check, or a 
      combination thereof; with some Services, funds may be credited to a bank, prepaid or credit card, or similar 
      account. Beneficiary may be able to elect a payout method that differs from the payout method you specify; 
      you authorize Barri to honor Beneficiary's election of payout method. Beneficiaries who choose to receive 
      funds through a payout method other than cash or in a currency other than the one you selected may incur 
      additional fees to access funds. Certain countries and/or jurisdictions may impose a tax, fee and/or tariff on 
      your transaction and/ or Beneficiary's receipt of, or access to, transferred funds. Transactions:
      </li>
  </ol>
  <ol class="pydocx-list-style-type-lowerRoman">
    <li>which exceed certain amounts;</li>
    <li>to certain destinations;</li>
    <li>that implicate certain regulatory issues or consumer protection issues; or</li>
    <li>sent through delayed options may take longer, be subject to dollar limits or be subject to additional Restrictions. </li>
  </ol>
  <p>Transactions may be reported to applicable authorities. Messaging and notification services may incur additional 
  fees. In some destinations Beneficiary may be required to provide identification to receive funds in cash. Barri relies 
  on the information you provide us to send money. Please review all transaction details for accuracy before 
  completing your transaction.
  </p>
  <p>
    <span style="margin-left:3.00em">2. <strong>ADMINISTRATION CHARGE</strong>: Transactions not picked up or canceled by you within one year of the send date will 
    be assessed a non-refundable administration charge of up to fifty cents per month from the send date, not to exceed 
    forty-two dollars, which will be deducted from the amount sent (or where such charge exceeds the maximum 
    amount permitted by law, the maximum amount permitted by law).
    
    </span>
  </p>
  <p>
    <span style="margin-left:3.00em">
    3. <strong>REFUNDS</strong>: : Subject to applicable law: (i) transfers may be canceled for a refund of the principal amount, unless the 
    funds have been picked up or deposited at the time Barri receives Your written request; (ii) for certain services, 
    excluding Barri's bill payment and prepaid products and services, Barri may provide a transfer fee refund if funds are 
    not available within the specified timeframe; and (iii) Barri may charge you a fee to refund the principal amount back 
    to you in those instances where Beneficiary rejects your funds. Qualifying refunds for transfers that begin and end 
    in the United States will be made within 45 days of receipt of your valid written request. Barri may issue your refund 
    through a Barri money transfer or Barri may issue the refund to the credit or debit card that was used to pay for the transaction. In lieu of receiving 
    the refund by Barri money transfer, you may request Barri to mail you a check in the 
    amount of the refund. Where required by law, refunds associated with certain international transfers may be eligible 
    for different treatment.
    </span>
  </p>
  <p>
      <span style="margin-left:3.00em"> 4. <strong>SPECIAL TERMS FOR INTERNATIONAL TRANSFERS</strong>: Notwithstanding the foregoing, and subject to applicable law, international
    transfers may be canceled for a full refund of the principal and fees paid within 30 minutes of payment, unless the funds
    have been picked up or deposited. You may also receive a full refund in certain circumstances if you successfully assert
    an error or as otherwise provided under applicable law.
      </span>
  </p>
  <p>
    <span style="margin-left:3.00em">5. <strong>ARBITRATION AND WAIVER OF CLASS REMEDY AND JURY TRIAL</strong>: UNLESS OTHERWISE REQUIRED BY APPLICABLE
    LAW, ANY CONTROVERSY OR CLAIM ARISING OUT OF OR RELATING TO A TRANSFER, THE AGREEMENT OR BREACH 
    OF THIS AGREEMENT, INCLUDING STATUTORY CONSUMER CLAIMS (EACH, A “DISPUTE”), SHALL BE SETTLED 
    EXCLUSIVELY BY ARBITRATION ADMINISTERED BY THE AMERICAN ARBITRATION ASSOCIATION ("AAA") UNDER ITS 
    COMMERCIAL ARBITRATION RULES AND, WHERE APPROPRIATE, THE AAA’S SUPPLEMENTARY PROCEDURES FOR 
    CONSUMER RELATED DISPUTES (“AAA CONSUMER RULES”), BOTH OF WHICH ARE AVAILABLE AT THE AAA WEBSITE 
    AT <a href="http://WWW.ADR.ORG">WWW.ADR.ORG</a> YOU UNDERSTAND THAT ABSENT THIS SECTION, YOU WOULD HAVE THE RIGHT TO SUE IN 
    COURT AND HAVE A JURY TRIAL.</span>
  </p>
  <p>
      <span style="margin-left:3.00em">THE DETERMINATION OF WHETHER A DISPUTE IS SUBJECT TO ARBITRATION, IF CONTESTED, SHALL BE GOVERNED 
      BY THE FEDERAL ARBITRATION ACT AND DETERMINED BY A COURT RATHER THAN AN ARBITRATOR. YOUR 
      ARBITRATION FEES AND YOUR SHARE OF ARBITRATOR COMPENSATION SHALL BE GOVERNED BY THE AAA RULES 
      AND, WHERE APPROPRIATE, LIMITED BY THE AAA CONSUMER RULES. IF SUCH COSTS ARE DETERMINED BY THE 
      ARBITRATOR TO BE EXCESSIVE, WE WILL PAY ALL ARBITRATION FEES AND EXPENSES. THE ARBITRATION MAY BE 
      CONDUCTED IN PERSON, THROUGH THE SUBMISSION OF DOCUMENTS, BY PHONE OR ONLINE, AT YOUR ELECTION, 
      SUBJECT TO THE DETERMINATION OF THE ARBITRATOR. IF IN PERSON, ANY ARBITRATION HEARING THAT YOU 
      ATTEND SHALL TAKE PLACE IN THE FEDERAL JUDICIAL DISTRICT OF YOUR RESIDENCE.      
      </span>
  <p/>
  <p>
    <span style="margin-left:3.00em"><strong>RESTRICTIONS</strong>. YOU AND WE AGREE THAT ANY ARBITRATION SHALL BE LIMITED TO THE DISPUTE BETWEEN YOU 
    AND US INDIVIDUALLY. TO THE FULL EXTENT PERMITTED BY LAW, (1) NO ARBITRATION SHALL BE JOINED WITH ANY 
    OTHER; (2) THERE IS NO RIGHT OR AUTHORITY FOR ANY DISPUTE TO BE ARBITRATED ON A CLASS-ACTION BASIS OR 
    TO UTILIZE CLASS ACTION PROCEDURES; AND (3) THERE IS NO RIGHT OR AUTHORITY FOR ANY DISPUTE TO BE 
    BROUGHT IN A PURPORTED REPRESENTATIVE CAPACITY ON BEHALF OF THE GENERAL PUBLIC OR ANY OTHER 
    PERSONS. ANY DISPUTE MUST BE INITIATED WITHIN ONE YEAR AFTER THE COMPLAINING PARTY DISCOVERS THE 
    FACTS THAT FORM THE BASIS FOR THE CONTROVERSY OR CLAIM, OR IT IS FOREVER WAIVED.
    </span>
  <p/>
  <p>
    <span style="margin-left:3.00em">
    <strong>Exceptions to Arbitration.</strong> You and we agree that the following Disputes (and only these Disputes) are not subject 
    to the above provisions concerning binding arbitration and may be brought in any court having jurisdiction over the 
    parties and subject matter: (1) any suit to compel arbitration, stay proceeding pending arbitration, or to confirm, 
    modify, vacate or enter judgment on the award entered by the arbitrator; and (2) any suit to seek temporary 
    injunctive relief that will remain in place only until an arbitrator can determine whether the relief should be 
    continued, modified or removed.
    </span>
  <p/>
  <p>
    <span style="margin-left:3.00em">
    <strong>Severability.</strong> You and we agree that if any portion of this Section is found illegal or unenforceable, that portion shall 
    be severed and the remainder of the Section shall be given full force and effect
    </span>
  <p/>


  <p>
    <span style="margin-left:3.00em">6.
    <strong>LIMITATIONS OF LIABILITY</strong>: EXCEPT AS OTHERWISE SET FORTH IN THIS USER AGREEMENT OR PROVIDED BY 
    APPLICABLE LAW, IN NO EVENT SHALL BARRI, ITS SUPPLIERS, VENDORS, SERVICE PROVIDERS, SERVICE COMPANIES, 
    OR THEIR RESPECTIVE SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS, AGENTS, PARTNERS, EMPLOYEES OR 
    CONSULTANTS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY 
    DAMAGES, INCLUDING BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER 
    INTANGIBLE LOSSES (EVEN IF BARRI HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES) RESULTING FROM 
    NEGLIGENCE ON THE PART OF BARRI, ITS SUPPLIERS, VENDORS, SERVICE PROVIDERS, SERVICE COMPANIES, OR 
    THEIR RESPECTIVE SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS, AGENTS, PARTNERS, EMPLOYEES OR 
    CONSULTANTS.
    </span>
  </p>

  <p>
    <span style="margin-left:3.00em"><strong>Notwithstanding the foregoing:</strong>
    </span>
  <p/>
  <p>
    <span style="margin-left:3.00em"><strong>California residents: </strong> the above does not apply to claims under Section 2102 of the California Financial Code arising 
    from Transactions originating in California.</span>
  </p>

  <p>
    <span style="margin-left:3.00em">7.
    <strong>CURRENCY EXCHANGE, INTERNATIONAL SERVICES</strong>: In addition to the transfer fees applicable to this transaction, 
    a currency exchange rate will be applied. United States currency is converted to foreign currency at an exchange 
    rate set by Barri unless the laws of the Expected Payout Location do not permit Barri to set an exchange rate. Any 
    difference between the rate given to you and the rate received by Barri will be kept by Barri (and its Agents in some 
    cases) in addition to the transfer fees. Subject to applicable law, the actual or estimated currency exchange rate 
    applicable to your transaction will be provided to you on the written disclosures provided to you by Barri in 
    connection with your transaction. Payouts will generally be made in the national currency of the Expected Payout 
    Location ("Local Currency"). In some countries, you may designate a payout currency other than the Local Currency; 
    however, the alternate currency you choose may not be available at all Agent locations. Barri is not responsible for 
    the currency exchange rate that will be applied if Beneficiary chooses to receive a currency other than the currency 
    you selected.</span>
  </p>
  <p>
    <span style="margin-left:3.00em">8.
    <strong>IDENTITY AND LOCATION VERIFICATION</strong>: YOU AUTHORIZE BARRI TO REQUEST YOUR MOBILE CARRIER TO USE 
    YOUR MOBILE SUBSCRIBER DETAILS FOR VERIFYING YOUR IDENTITY. THOSE DETAILS MAY INCLUDE NAME, BILLING 
    ADDRESS, EMAIL, AND PHONE NUMBER. THIS INFORMATION MAY ALSO INCLUDE LOCATION INFORMATION, IF 
    AVAILABLE.
    </span>
  </p>
  <p>
    <span style="margin-left:3.00em">9.
    <strong>USING AN ACCOUNT</strong>: Where available, Barri may allow you send money from or to a bank, a prepaid or credit 
    card, a biller, or a similar account (collectively, "Accounts"). The bank or other provider of an Account (the "Account 
    Provider") may impose additional fees on an Account. The agreement with the Account Provider governs use of an 
    Account and provides the rights and liabilities of the holder of an Account. Unless required by applicable law, Barri 
    accepts no responsibility to you or any Account holder for any fees imposed by an Account provider. If the currency 
    you select for a transaction is not the currency in which an Account is denominated, the Account provider may 
    convert the funds at its own currency exchange rate or reject the transfer. Account Services are for personal or 
    individual use only and not for use by or on behalf of any business or legal entity. Barri may use the Automated 
    Clearing House ("ACH") network, book transfer, electronic funds transfer, wire transfer or other methods to process 
    transactions relating to an Account. Barri is not responsible for actions taken by the Account Provider, such as 
    improperly posting a transaction.    
    </span>
  </p>
  <ol class="pydocx-list-style-type-upperLetter">
    <li>
      <strong>IMPORTANT NOTICE FOR USING ACCOUNTS</strong>: MAKE SURE THE ACCOUNT NUMBER, ACCOUNT PROVIDER 
      DETAILS, AND CURRENCY SELECTED ARE CORRECT BEFORE SENDING. IF THE ACCOUNT NUMBER OR ACCOUNT 
      PROVIDER DETAILS ARE INCORRECT, MONEY MAY BE DEBITED OR CREDITED TO THE WRONG ACCOUNT AND 
      MAY NOT BE RECOVERED.<br/>
      Barri may rely on information you provide and may rely solely on the Account numbers and identifying 
      numbers that you provide for identifying an Account and/ or Account Provider, regardless of whether or not 
      you also provide the name of the Account holder or the name of the Account Provider.
    </li>
    <br/>
    <li>
      <strong>TRANSFERS TO ACCOUNTS</strong>:  Beneficiary's agreement with the Account Provider governs Beneficiary's rights, 
      liabilities and fees (including fees to transfer cash out of an Account), and the Account Provider may impose 
      its own restrictions regarding funds availability, limits that may be transferred to or held in an Account, hours 
      of operations, holidays or other limitations. In most cases, Beneficiary must be enrolled in the Account 
      program to receive such a transfer. A Beneficiary who is not enrolled in the Account program may be able to 
      receive funds at an Agent location and may be subject to additional requirements. Barri may make money 
      from fees associated with use of Accounts.
    </li>
    <br/>
    <li>
      <strong>TRANSFERS FROM ACCOUNTS</strong>: By initiating a transaction from an Account (an "Account Funded Transaction"), 
      you (i) affirm you are the owner of the Account and have authority to initiate the transaction and (ii) authorize 
      Barri to initiate electronic debits and credits to your Account to process and correct errors or if a transaction 
      cannot be completed. Barri may by law be liable for damages caused by its failure to debit your Account in 
      accordance with these terms and conditions, in the correct amount or in a timely manner when properly 
      instructed by you. However, Barri will not be liable where: (1) You do not have enough money available in your 
      Account; (2) Your Account is closed or withdrawals restricted; (3) the transaction exceeds dollar or frequency 
      limitations imposed by Barri or your Account Provider; (4) circumstances beyond Barri's control (such as flood, 
      fire, power outages, mechanical or system failures); (5) Your Account Provider does not honor a transaction, 
      the transaction is not processed or the transaction is returned by your Account Provider; (6) Your instructions 
      are lost or delayed in transmission to Barri; (7) Barri fails to process your transaction because of a reasonable 
      security concern or the Service option has been discontinued or suspended, or Barri otherwise advises you 
      that your request will not be processed; and (8) other exceptions allowed by law. 
    </li>
  </ol>
  <p>
    <span style="margin-left:3.00em">10.
    <strong>USE OF THE BARRI WEBSITE, MOBILE DEVICE AND TABLET SERVICES</strong></span>
  </p>
  <ol class="pydocx-list-style-type-upperLetter">
    <li>
      <strong>LOCATION BASED SERVICES</strong>: : You acknowledge and authorize that information concerning the location of your 
      mobile device may be used to assess location. Location may be obtained at any time while logged into this 
      website. Location information will not be disclosed to others. You expressly agree that you authorize Barri to 
      collect and use your location as a part of the Barri website and eligibility for use of the website.
    </li>
    <br/>
    <li>
      <strong>INTELLECTUAL PROPERTY</strong>: : You acknowledge and authorize that information concerning the location of your 
      mobile device may be used to assess location. Location may be obtained at any time while logged into this 
      website. Location information will not be disclosed to others. You expressly agree that you authorize Barri to 
      collect and use your location as a part of the Barri website and eligibility for use of the website.
    </li>
    <br/>
    <li>
      <strong>LINKS TO OTHER SITES</strong>: The Website may contain links and pointers to other World Wide Web Internet sites 
      and resources (the "Linked Sites"). Links to any Linked Site do not constitute an endorsement by or association 
      with Barri or any of its affiliates. Links do not imply that Barri is associated with or legally authorized to use 
      any trademark, trade name, logo or author symbol displayed in or accessible through the links, or that any 
      Linked Sites are authorized to use any trademark, trade name, logo or author symbol of Barri or any of its 
      affiliates. You should direct any concerns regarding any Linked Site to such Linked Site's site administrator or 
      webmaster. Barri does not represent or endorse the accuracy or reliability of, and expressly disclaims, any 
      advice, opinion, statement, or other information displayed or distributed through any Linked Site. You agree 
      that reliance upon any opinion, advice, or information displayed on or otherwise available through any Linked 
      Site shall be at your sole risk.
    </li>
    <br/>
    <li>
      <strong>IDENTITY VERIFICATION</strong>: You acknowledge your mobile carrier may share your mobile subscriber details with 
      Barri for identity verification. Those details may include name, billing address, email, and phone number.</li>
  </ol>
  <p>
    <span style="margin-left:3.00em">11.
    <strong>PRIVACY</strong>: We may collect and disclose personal information to third parties as explained in our Privacy 
    Statement. To get a copy, visit barrigroup.com or call 1-800-926-2277. We collect personal information, for example, 
    when you transact with us and other companies; submit information on applications, forms, and by other means; 
    use or visit our or other apps or online sites; enter a promotion; register for communications; or join a loyalty 
    program. We also collect information from many sources and may collect, track and combine information across 
    devices, platforms and channels. Information disclosed may include financial data (e.g., information on transactions 
    with us and other financial matters), contact information, identification, computer, mobile device and social network 
    information. Recipients may include financial and non-financial companies, service providers, government agencies 
    and direct marketers. You may direct us to limit certain disclosures, and your choice will apply until you change Your 
    choice or we delete your data. To limit disclosures (opt out), call 1-800-926-2277.
    </span>
  </p>
  <p>
    <span style="margin-left:3.00em"> 12.
    <strong>GENERAL</strong>: This Agreement, together with all items incorporated by reference, embodies the entire 
    understanding among the parties. It supersedes all prior understandings and cannot be modified orally. Subject to 
    applicable law, Barri may assign this Agreement to a third party without your consent. This Agreement is governed 
    by Texas law without regard to conflicts of law rules. If an Agreement provision is found invalid, remaining provisions 
    shall be valid. Services are directed solely to persons 18 and over. The English language version controls if there is 
    an inconsistency between English and non-English Agreement versions. You and Beneficiary represent that your use 
    of Services does not violate this Agreement or any law, including, without limit, laws relating to money laundering, 
    illegal gambling activities, support for terrorist activities or fraud. Information you provide Barri shall be truthful and 
    complete. You shall indemnify Barri and its Agents for all losses of any kind (including attorney fees) arising out of 
    any Agreement breach by you or Beneficiary. Barri reserves the right to change Services without notice. Barri and its 
    Agents may refuse to provide Services to any person.
    </span>
  </p>
  <p>
    <span style="margin-left:3.00em">13.<strong> CONSUMER FRAUD ALERT:  PROTECT YOURSELF. BE CAREFUL WHEN A STRANGER ASKS YOU TO SEND MONEY, 
    ESPECIALLY FOR INTERNET AUCTIONS, NEWSPAPER OR TELEPHONE OFFERS.</strong> Barri does not guarantee delivery or suitability of goods or services
     paid for with Services. Barri is not an escrow service provider. You and Receiver agree 
    not to use Services for escrow purposes.
    </span>
  <p/>

  
  <p>
    <span style="margin-left:3.00em"><strong>March 2021</strong>
    </span>
  <p/>
  `
{/* </body>

</html> */}

module.exports = termsEN;


// WEBPACK FOOTER //
// ./public/documents/Terms-and-Conditions-en.js